(() => {
  const DONUTS_COLLECTION = 'donuts-flavors';
  const SAUCES_COLLECTION = 'donuts-sauces';

  const DONUTS_BOX_VARIANT_ID = 53587378504010;

  const LIMIT_DEFAULT = 4;

  const $ = (s) => document.querySelector(s);

  const el = (tag, attrs = {}, children = []) => {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') n.className = v;
      else if (k === 'html') n.innerHTML = v;
      else n.setAttribute(k, v);
    });
    children.forEach((c) => n.appendChild(c));
    return n;
  };

  const getBoxLimit = () => {
    const p = new URLSearchParams(location.search);
    const raw = parseInt(p.get('box') || '', 10);
    return Number.isFinite(raw) && raw > 0 ? raw : LIMIT_DEFAULT;
  };

  async function fetchCollectionProducts(handle) {
    const url = `/collections/${handle}/products.json?limit=250`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Failed to fetch ${url}`);
    const data = await res.json();
    return (data.products || []).filter(p => (p.variants || []).some(v => v.available));
  }

  function firstAvailableVariant(product) {
    const v = (product.variants || []).find(x => x.available) || (product.variants || [])[0];
    return v || null;
  }

  function imgOf(p) {
    return (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
  }

  async function addItemsToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const t = await res.text();
      throw new Error(t || 'Add to cart failed');
    }
    return res.json();
  }

  async function init() {
    const root = document.querySelector('.smb-builder[data-builder="donuts"]');
    if (!root) return;

    root.classList.add('smbD--ready');

    const sticky = document.getElementById('smb-sticky');
    if (sticky && sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    const limit = getBoxLimit();

    const selectedEl = $('#smb-selected');
    const limitEl = $('#smb-limit');
    const selectedEl2 = $('#smb-selected-2');
    const limitEl2 = $('#smb-limit-2');

    const flavorsWrap = $('#smb-flavors');
    const saucesWrap = $('#smb-sauces');
    const boxInner = $('#smb-box-inner');

    const addBtn = $('#smb-add');
    const step2 = $('#smb-step2');

    const err = $('#smb-error');

    const saucePillText = $('#smb-sauce-pill-text');
    const sauceSticky = $('#smb-sauce-2');
    const stickySub = $('#smb-sticky-sub');

    if (!selectedEl || !limitEl || !flavorsWrap || !saucesWrap || !boxInner || !addBtn || !step2) return;

    boxInner.classList.add('smb-virtualBox');

    limitEl.textContent = String(limit);
    if (limitEl2) limitEl2.textContent = String(limit);

    const showError = (msg) => { err.style.display = ''; err.textContent = msg; };
    const clearError = () => { err.style.display = 'none'; err.textContent = ''; };

    let donuts = [];
    let sauces = [];
    const state = new Map();

    let pickedSauceVariantId = null;
    let pickedSauceTitle = '';
    let pickedSauceImg = '';

    const selectedCount = () => {
      let sum = 0;
      for (const q of state.values()) sum += q;
      return sum;
    };

    function buildSelectedFlat() {
      const out = [];
      for (const [pid, qty] of state.entries()) {
        const p = donuts.find(x => String(x.id) === String(pid));
        if (!p) continue;
        const img = imgOf(p);
        for (let i = 0; i < qty; i++) out.push({ title: p.title, img });
      }
      return out;
    }

    const VIRTUAL_LAYOUTS = {
      4: {
        donuts: [
          { x: 24, y: 36, s: 34, r: 0 },
          { x: 54, y: 36, s: 34, r: 0 },
          { x: 24, y: 74, s: 34, r: 0 },
          { x: 54, y: 74, s: 34, r: 0 },
        ],
        dip: { x: 84, y: 50, w: 30, h: 30 }
      },
      6: {
        donuts: [
          { x: 20, y: 60, s: 16, r: 0 },
          { x: 36, y: 60, s: 16, r: 0 },
          { x: 52, y: 60, s: 16, r: 0 },
          { x: 20, y: 80, s: 16, r: 0 },
          { x: 36, y: 80, s: 16, r: 0 },
          { x: 52, y: 80, s: 16, r: 0 },
        ],
        dip: { x: 84, y: 50, w: 30, h: 30 }
      },
      12: {
        donuts: [
          { x: 16, y: 55, s: 13, r: 0 },
          { x: 28, y: 55, s: 13, r: 0 },
          { x: 40, y: 55, s: 13, r: 0 },
          { x: 52, y: 55, s: 13, r: 0 },
          { x: 16, y: 72, s: 13, r: 0 },
          { x: 28, y: 72, s: 13, r: 0 },
          { x: 40, y: 72, s: 13, r: 0 },
          { x: 52, y: 72, s: 13, r: 0 },
          { x: 16, y: 89, s: 13, r: 0 },
          { x: 28, y: 89, s: 13, r: 0 },
          { x: 40, y: 89, s: 13, r: 0 },
          { x: 52, y: 89, s: 13, r: 0 },
        ],
        dip: { x: 84, y: 50, w: 30, h: 30 }
      }
    };

    function renderBoxPreview() {
      const wmNode = document.getElementById('smb-wm');
      const total = selectedCount();

      boxInner.innerHTML = '';
      if (wmNode) boxInner.appendChild(wmNode);
      if (wmNode) wmNode.classList.toggle('is-hidden', total > 0);

      const layout = VIRTUAL_LAYOUTS[limit] || VIRTUAL_LAYOUTS[4];
      const flat = buildSelectedFlat().slice(0, limit);

      layout.donuts.forEach((pos, idx) => {
        const it = flat[idx];
        if (!it || !it.img) return;

        const slot = el('div', { class: 'smb-slot', title: it.title }, [
          el('img', { src: it.img, alt: it.title, loading: 'lazy' })
        ]);

        slot.style.left = `${pos.x}%`;
        slot.style.top = `${pos.y}%`;
        slot.style.width = `${pos.s}%`;
        slot.style.height = `${pos.s}%`;
        slot.style.transform = `translate(-50%, -50%) rotate(${pos.r || 0}deg)`;

        boxInner.appendChild(slot);
      });

      const dip = layout.dip;
      const dipSlot = el(
        'div',
        {
          class: `smb-slot smb-slot--dip ${pickedSauceImg ? 'is-in' : 'is-empty'}`,
          title: pickedSauceTitle ? `Dip: ${pickedSauceTitle}` : 'Kies dip'
        },
        [
          pickedSauceImg
            ? el('img', { src: pickedSauceImg, alt: pickedSauceTitle, loading: 'lazy' })
            : el('div', { class: 'smb-dipPlaceholder', html: 'Kies dip' })
        ]
      );

      dipSlot.style.left = `${dip.x}%`;
      dipSlot.style.top = `${dip.y}%`;
      dipSlot.style.width = `${dip.w}%`;
      dipSlot.style.height = `${dip.h}%`;
      dipSlot.style.transform = `translate(-50%, -50%)`;

      boxInner.appendChild(dipSlot);
    }

    function syncCounters() {
      const total = selectedCount();
      selectedEl.textContent = String(total);
      if (selectedEl2) selectedEl2.textContent = String(total);
    }

    function updateSauceUI() {
      const txt = pickedSauceTitle ? pickedSauceTitle : 'Nog niet gekozen';
      if (saucePillText) saucePillText.textContent = txt;
      if (sauceSticky) sauceSticky.textContent = pickedSauceTitle ? pickedSauceTitle : '—';
    }

    function updateStep2Visibility() {
      const doneFlavors = selectedCount() === limit;
      step2.classList.toggle('is-open', doneFlavors);
      if (doneFlavors) {
        stickySub.textContent = pickedSauceVariantId
          ? 'Klaar! Je kunt toevoegen aan je winkelwagen.'
          : 'Kies nu 1 dip om verder te gaan.';
      } else {
        stickySub.textContent = 'Vul de box om dip te kiezen.';
        pickedSauceVariantId = null;
        pickedSauceTitle = '';
        pickedSauceImg = '';
      }
    }

    function updateAddButton() {
      const ok = (selectedCount() === limit) && !!pickedSauceVariantId;
      addBtn.disabled = !ok;
    }

    function updateUI() {
      syncCounters();
      updateSauceUI();
      updateStep2Visibility();
      updateAddButton();
      renderBoxPreview();
    }

    function renderFlavors() {
      flavorsWrap.innerHTML = '';
      if (!donuts.length) {
        flavorsWrap.textContent = 'Geen donut-smaken gevonden in deze collectie.';
        return;
      }

      donuts.forEach((p) => {
        const v = firstAvailableVariant(p);
        if (!v) return;

        const pid = String(p.id);
        const imgUrl = imgOf(p);
        const qty = state.get(pid) || 0;

        const minus = el('button', { type: 'button', 'data-action':'minus', 'data-pid':pid });
        minus.textContent = '−';
        minus.disabled = qty === 0;

        const plus = el('button', { type: 'button', 'data-action':'plus', 'data-pid':pid });
        plus.textContent = '+';
        plus.disabled = selectedCount() >= limit;

        const qtyEl = el('span', { html: String(qty) });
        const qtyWrap = el('div', { class: 'smbQty' }, [minus, qtyEl, plus]);

        const row = el('div', { class: 'smbRow', 'data-pid': pid }, [
          el('img', { src: imgUrl, alt: p.title, loading: 'lazy' }),
          el('div', { class:'smbRow__text' }, [
            el('p', { class:'smbRow__title', html: p.title }),
            el('p', { class:'smbRow__sub', html: 'Tik op + om toe te voegen' })
          ]),
          qtyWrap
        ]);

        flavorsWrap.appendChild(row);
      });
    }

    function renderSauces() {
      saucesWrap.innerHTML = '';
      if (!sauces.length) {
        saucesWrap.textContent = 'Geen dips gevonden in deze collectie.';
        return;
      }

      sauces.forEach((p) => {
        const v = firstAvailableVariant(p);
        if (!v) return;

        const imgUrl = imgOf(p);
        const on = pickedSauceVariantId === v.id;

        const row = el('div', { class: 'smbRow smbRow--pick', 'data-vid': String(v.id) }, [
          el('img', { src: imgUrl, alt: p.title, loading: 'lazy' }),
          el('div', { class:'smbRow__text' }, [
            el('p', { class:'smbRow__title', html: p.title }),
            el('p', { class:'smbRow__sub', html: 'Kies 1 dip' })
          ]),
          el('div', { class:'smbPick' }, [ el('span', { class: `smbRadio ${on ? 'on' : ''}` }) ])
        ]);

        saucesWrap.appendChild(row);
      });
    }

    flavorsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-action][data-pid]');
      if (!btn) return;
      clearError();
      const pid = btn.getAttribute('data-pid');
      const action = btn.getAttribute('data-action');
      const cur = state.get(pid) || 0;

      if (action === 'minus') {
        const next = cur - 1;
        if (next <= 0) state.delete(pid);
        else state.set(pid, next);
      }
      if (action === 'plus') {
        if (selectedCount() >= limit) return;
        state.set(pid, cur + 1);
      }
      renderFlavors();
      updateUI();
    });

    saucesWrap.addEventListener('click', (e) => {
      const row = e.target.closest('.smbRow--pick[data-vid]');
      if (!row) return;

      clearError();

      const vid = Number(row.getAttribute('data-vid'));
      const p = sauces.find(x => (firstAvailableVariant(x)?.id) === vid);
      if (!p) return;

      const v = firstAvailableVariant(p);

      if (pickedSauceVariantId === v.id) {
          pickedSauceVariantId = null;
          pickedSauceTitle = '';
          pickedSauceImg = '';
      } else {
          pickedSauceVariantId = v.id;
          pickedSauceTitle = p.title;
          pickedSauceImg = imgOf(p);
      }

      renderSauces();
      updateUI();
    });

    addBtn.addEventListener('click', async () => {
      clearError();
      if (selectedCount() !== limit) return;
      if (!pickedSauceVariantId) return;

      const properties = {
        box_type: 'donuts',
        box_size: String(limit),
        dip: pickedSauceTitle || '—',
      };

      let i = 1;
      const flavorsSummary = [];
      for (const [pid, qty] of state.entries()) {
        const p = donuts.find(x => String(x.id) === String(pid));
        if (!p || !qty) continue;
        const label = `${p.title} (${qty})`;
        properties[`flavor_${i}`] = label;
        flavorsSummary.push(label);
        i++;
      }
      properties.flavors = flavorsSummary.join(', ');

      addBtn.disabled = true;
      addBtn.textContent = 'Toevoegen…';

      try {
        const items = [];
        items.push({ id: DONUTS_BOX_VARIANT_ID, quantity: 1, properties });
        await addItemsToCart(items);
        window.location.href = '/cart';
      } catch (e) {
        console.error(e);
        showError('Er ging iets mis met de winkelwagen. Probeer opnieuw.');
        addBtn.textContent = 'In winkelwagen';
        addBtn.disabled = false;
      }
    });

    try {
      donuts = await fetchCollectionProducts(DONUTS_COLLECTION);
      renderFlavors();
    } catch (e) {
      console.error(e);
      flavorsWrap.textContent = 'Kon donut-smaken niet laden.';
      return;
    }
    try {
      sauces = await fetchCollectionProducts(SAUCES_COLLECTION);
      renderSauces();
    } catch (e) {
      console.error(e);
      saucesWrap.textContent = 'Kon dips niet laden.';
    }
    updateUI();
  }

  document.addEventListener('DOMContentLoaded', init);
})();